import styled from '@emotion/styled';

const Skeleton = styled('div')`
  min-height: 240px;
  width: 100%;
`;

// Shown in place of a route's page content while its real data is still
// being fetched in the background (see WWSQueryContext), instead of
// rendering that route's stripped (image-free) SSR data.
function PageContentsSkeleton() {
  return <Skeleton data-testid="page-contents-skeleton" />;
}

export default PageContentsSkeleton;
